<template>
  <main class="container">
    <div v-if="!pokemon" class="loading">
      <img src="../assets/pokeball.svg" alt="pokeball" width="250" />
    </div>
    <div v-else class="row card bg-danger">
      <div class="col-lg-6 border-red bg-danger">
        <div class="row card order-1 order-lg-1 bg-white m-20">
          <PokemonPicture
            :pokemon="pokemon"
            :pokemon-id="pokemon.id"
            :show-pokemon="showPokemon"
          />
        </div>
        <div class="col-12 order-2 order-lg-3 bg-danger text-center">
          <PokemonOptions
            :pokemons="pokemonArr"
            :can-choose="!showAnswer"
            :message="message"
            :show-pokemon="showPokemon"
            :reloading="reloading"
            @selection="checkAnswer"
            @reload="newGame"
          />
        </div>
      </div>
      <div class="col-lg-6 order-3 order-lg-2 border-red bg-danger">
        <PokemonInfo :pokemon="pokemon" :show-info="showPokemon" />
      </div>
    </div>
  </main>
</template>

<script>
import PokemonInfo from '@/components/PokemonInfo.vue'
import PokemonOptions from '@/components/PokemonOptions.vue'
import PokemonPicture from '@/components/PokemonPicture'

import getPokemonOptions from '@/helpers/getPokemonOptions'

export default {
  name: 'Home',
  components: {
    PokemonInfo,
    PokemonOptions,
    PokemonPicture,
  },
  data() {
    return {
      pokemonArr: [],
      pokemon: null,
      showPokemon: false,
      showAnswer: false,
      reloading: false,
      message: '',
    }
  },
  methods: {
    async mixPokemonArray() {
      this.pokemonArr = await getPokemonOptions()

      const randomNumber = Math.floor(Math.random() * this.pokemonArr.length)
      this.pokemon = this.pokemonArr[randomNumber]
      this.reloading = false
    },
    checkAnswer(pokemonId) {
      this.showPokemon = true
      this.showAnswer = true

      if (pokemonId === this.pokemon.id) {
        this.message = `Correcto, es ${this.pokemon.name}`
      } else {
        this.message = `Oops, era ${this.pokemon.name}`
      }
    },
    async newGame() {
      this.pokemonArr = []
      // this.pokemon = null
      this.reloading = true
      this.showPokemon = false
      this.showAnswer = false
      this.message = ''
      await this.mixPokemonArray()
    },
  },
  mounted() {
    this.mixPokemonArray()
  },
}
</script>

<style lang="scss">
body {
  background-image: url('../../src/assets/background.png') !important;
}
.loading {
  margin: 0px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.border-red {
  border-width: var(--base-border-width);
  border-style: solid;
  border-color: var(--danger-color);
}
@font-face {
  font-family: 'PokemonHollowNormal';
  src: url('../../src/assets/fonts/PokemonHollowNormal-pyPZ.ttf');
}
@font-face {
  font-family: 'PokemonSolidNormal';
  src: url('../../src/assets/fonts/PokemonSolidNormal-xyWR.ttf');
}
@font-face {
  font-family: 'PokemonGb';
  src: url('../../src/assets/fonts/PokemonGb-RAeo.ttf');
}
.poke-font-normal {
  font-family: 'PokemonHollowNormal';
}
.poke-font-solid {
  font-family: 'PokemonSolidNormal';
}
.poke-font-gb-regular {
  font-family: 'PokemonGb';
}
</style>
